import React from "react";
import { FaPlus, FaTrash } from "react-icons/fa";

function ProjectSpecifications({
  formData,
  handleSpecificationChange,
  handleAddSpecification,
  handleRemoveSpecification,
  handleHighlightChange,
  handleAddHighlight,
  handleRemoveHighlight,
  handleWhyBuyChange,
  handleAddWhyBuy,
  handleRemoveWhyBuy,
}) {
  return (
    <fieldset className="border border-gray-300 p-4 rounded-md">
      <legend className="text-lg font-semibold px-2">Project Specifications & Highlights</legend>

      {/* Specifications (Dynamic List) */}
      <div className="mt-4">
        <label className="block text-gray-700 font-medium">Specifications</label>
        {formData.specifications.map((spec, index) => (
          <div key={index} className="flex items-center gap-2 mt-2">
            <input
              type="text"
              value={spec}
              onChange={(e) => handleSpecificationChange(e, index)}
              placeholder={`Specification ${index + 1}`}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
            <button
              type="button"
              onClick={() => handleRemoveSpecification(index)}
              className="p-2 bg-red-500 text-white rounded-md hover:bg-red-600"
            >
              <FaTrash size={16} />
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={handleAddSpecification}
          className="mt-2 flex items-center bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
        >
          <FaPlus size={16} className="mr-1" /> Add Specification
        </button>
      </div>

      {/* Key Highlights (Dynamic List) */}
      <div className="mt-6">
        <label className="block text-gray-700 font-medium">Key Highlights</label>
        {formData.keyHighlights.map((highlight, index) => (
          <div key={index} className="flex items-center gap-2 mt-2">
            <input
              type="text"
              value={highlight}
              onChange={(e) => handleHighlightChange(e, index)}
              placeholder={`Highlight ${index + 1}`}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
            <button
              type="button"
              onClick={() => handleRemoveHighlight(index)}
              className="p-2 bg-red-500 text-white rounded-md hover:bg-red-600"
            >
              <FaTrash size={16} />
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={handleAddHighlight}
          className="mt-2 flex items-center bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
        >
          <FaPlus size={16} className="mr-1" /> Add Highlight
        </button>
      </div>

      {/* Why Buy (Dynamic List) */}
      <div className="mt-6">
        <label className="block text-gray-700 font-medium">Why Buy</label>
        {formData.whyBuy.map((reason, index) => (
          <div key={index} className="flex items-center gap-2 mt-2">
            <input
              type="text"
              value={reason}
              onChange={(e) => handleWhyBuyChange(e, index)}
              placeholder={`Reason ${index + 1}`}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
            <button
              type="button"
              onClick={() => handleRemoveWhyBuy(index)}
              className="p-2 bg-red-500 text-white rounded-md hover:bg-red-600"
            >
              <FaTrash size={16} />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={handleAddWhyBuy}
          className="mt-2 flex items-center bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
        >
          <FaPlus size={16} className="mr-1" /> Add Reason
        </button>
      </div>

    </fieldset>
  );
}

export default ProjectSpecifications;
